/* ============================================================
   IMENHOF BLOOM — product.js
   Productpagina-gedrag: galerij (klik + swipe), variantkiezer
   (prijs/knop/URL/afbeelding) en sticky koopbalk (mobiel).
   Wordt alleen op de productpagina geladen (main-product.liquid).
   Zelfstandig: eigen money-helper, geen afhankelijkheid van theme.js.
   ============================================================ */
(function () {
  'use strict';

  const money = (cents) => window.Shopify && Shopify.formatMoney
    ? Shopify.formatMoney(cents, window.themeMoneyFormat)
    : '€' + (cents / 100).toFixed(2).replace('.', ',');

  /* ============================================================
     GALERIJ
     ============================================================ */
  function galleryActivate(g, idx) {
    const slides = g.querySelectorAll('.gallery__slide');
    const thumbs = g.querySelectorAll('.gallery__thumb');
    slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
  }
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    g.addEventListener('click', (e) => {
      const thumb = e.target.closest('.gallery__thumb');
      if (!thumb) return;
      const id = thumb.dataset.mediaId;
      g.querySelectorAll('.gallery__thumb').forEach((t) => t.classList.toggle('is-active', t === thumb));
      g.querySelectorAll('.gallery__slide').forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === id));
    });

    /* Swipe op touch */
    const main = g.querySelector('.gallery__main');
    const slideCount = g.querySelectorAll('.gallery__slide').length;
    if (!main || slideCount < 2) return;
    let startX = 0, startY = 0;
    main.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      const slides = Array.from(g.querySelectorAll('.gallery__slide'));
      const cur = slides.findIndex((s) => s.classList.contains('is-active'));
      const next = dx < 0 ? cur + 1 : cur - 1;
      if (next < 0 || next >= slides.length) return;
      galleryActivate(g, next);
    }, { passive: true });
  });

  /* ============================================================
     VARIANTKIEZER
     ============================================================ */
  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const section = picker.closest('section');
    if (!section) return;
    const form = section.querySelector('[data-product-form]');
    const variantsJson = picker.querySelector('[data-variants-json]');
    if (!form || !variantsJson) return;
    const data = JSON.parse(variantsJson.textContent);
    const idInput = form.querySelector('[name="id"]');
    const priceEls = section.querySelectorAll('[data-price]');
    const addBtn = form.querySelector('[type=submit]');
    const barBtn = section.querySelector('[data-buybar-add]');
    const gallery = section.querySelector('[data-gallery]');

    function currentOptions() {
      return Array.from(picker.querySelectorAll('input:checked')).map((i) => i.value);
    }
    function findVariant(opts) {
      return data.find((v) => v.options.every((o, idx) => o === opts[idx]));
    }
    function setButtons(disabled, label) {
      if (addBtn) { addBtn.disabled = disabled; addBtn.textContent = label; }
      if (barBtn) { barBtn.disabled = disabled; barBtn.textContent = label; }
    }
    function update() {
      const opts = currentOptions();
      const variant = findVariant(opts);
      // update label readouts
      picker.querySelectorAll('[data-option-value]').forEach((el) => {
        const grp = el.closest('.variant-group');
        const checked = grp.querySelector('input:checked');
        if (checked) el.textContent = checked.value;
      });
      if (!variant) {
        setButtons(true, 'Niet beschikbaar');
        return;
      }
      idInput.value = variant.id;
      let html = '<span class="price--current">' + money(variant.price) + '</span>';
      if (variant.compare_at_price > variant.price) {
        html += ' <span class="price--compare">' + money(variant.compare_at_price) + '</span>';
      }
      priceEls.forEach((el) => { el.innerHTML = html; });
      const label = variant.available ? (addBtn && addBtn.dataset.addLabel) || 'In winkelwagen' : 'Tijdelijk uitverkocht';
      setButtons(!variant.available, label);
      if (variant.featured_media && gallery) {
        const mid = String(variant.featured_media.id);
        const thumb = gallery.querySelector('.gallery__thumb[data-media-id="' + mid + '"]');
        if (thumb) thumb.click();
      }
      // reflect in URL
      if (history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }
    picker.addEventListener('change', update);
    update();
  });

  /* ============================================================
     VASTE MOBIELE KOOPBALK
     ============================================================ */
  const productSection = document.querySelector('[data-product-section]');
  if (productSection) {
    const productForm = productSection.querySelector('[data-product-form]');
    const originalAdd = productForm && productForm.querySelector('[type="submit"]');
    const mobileBuybar = productSection.querySelector('[data-mobile-buybar]');
    const mobileQuery = window.matchMedia('(max-width: 900px)');
    const root = document.documentElement;

    if (productForm && originalAdd && mobileBuybar) {
      let measureQueued = false;

      function setMobileBuybar(show) {
        mobileBuybar.classList.toggle('is-active', show);
        mobileBuybar.toggleAttribute('inert', !show);
        mobileBuybar.setAttribute('aria-hidden', show ? 'false' : 'true');
        root.classList.toggle('is-mobile-product-cta-visible', show);
      }

      function measureMobileBuybar() {
        measureQueued = false;
        if (!mobileQuery.matches) {
          root.classList.remove('has-mobile-product-cta');
          setMobileBuybar(false);
          return;
        }

        root.classList.add('has-mobile-product-cta');
        root.style.setProperty('--mobile-buybar-height', Math.ceil(mobileBuybar.offsetHeight) + 'px');

        const rect = originalAdd.getBoundingClientRect();
        const originalVisible = rect.bottom > 0 && rect.top < window.innerHeight;
        const drawerOpen = root.classList.contains('is-drawer-open');
        setMobileBuybar(!originalVisible && !drawerOpen);
      }

      function queueMobileBuybarMeasure() {
        if (measureQueued) return;
        measureQueued = true;
        requestAnimationFrame(measureMobileBuybar);
      }

      const originalObserver = new IntersectionObserver(queueMobileBuybarMeasure, {
        threshold: [0, 0.01, 1]
      });
      originalObserver.observe(originalAdd);

      const drawerObserver = new MutationObserver(queueMobileBuybarMeasure);
      drawerObserver.observe(root, { attributes: true, attributeFilter: ['class'] });

      window.addEventListener('scroll', queueMobileBuybarMeasure, { passive: true });
      window.addEventListener('resize', queueMobileBuybarMeasure, { passive: true });
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', queueMobileBuybarMeasure);

      measureMobileBuybar();
    }
  }
})();

